import { httpService } from '@/api/httpService'

const historyCheck = {
  state: {
    historyData:[]
  },
  mutations: {
    SET_HISTORY_DATA:(state, data) => {
      state.historyData = data
    }
  },
  actions: {
    getHistoryCheckData ({ commit }, ptDispNo) {
      return new Promise((resolve, reject) => {
        httpService({
          url: 'getHistoryData',
          method: 'get',
          params: {
            ptDispNo
          }
        }).then(response => {
          commit('SET_HISTORY_DATA', response.result.list)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default historyCheck
